export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
vm(require("crm-cards-sdk/lang/en.lyaml"));
vm(require("crm-component-utils/lang/en.lyaml"));
vm(require("crm-display-components/lang/en.lyaml"));
vm(require("customer-data-properties/lang/en.lyaml"));
at({ "en": { "crmRelativeTimeline": { "emptyState": "No data to display.", "propertyListTitle": "All properties on timeline" } } });
};